import React from 'react'
import './ourServiceCostsV4.css'

export default (props) => <div className='our-service-costs-blockV4'>
  <div className='wrapper2'>
    <div className='title'>{props.data.title}</div>
    <div className='message'>{props.data.subtitle}</div>
  </div>
</div>
